import { ReactElement, ReactNode } from 'react';
import Skeleton from 'react-loading-skeleton';
import {
  MapContainer as StyledMapContainer, MapContainerLoading, MapHeader,
} from './styles';
import { HistoryTooltip, TitleGraph } from '../styles';
import { InfoTooltip } from '../components/InfoTooltip';
import { useTranslation } from 'react-i18next';

interface MapContainerProps {
  loading: boolean;
  disabledTooltip: boolean;
  children: ReactNode;
}

export function MapContainer({
  children,
  disabledTooltip,
  loading,
}: Readonly<MapContainerProps>): ReactElement {
  const { t } = useTranslation();

  if (loading) {
    return (
      <MapContainerLoading>
        <div>
          <Skeleton
            height="22px"
            width="68px"
            borderRadius="100px"
            containerClassName="skeleton-container-span"
            className="skeleton-span"
          />
          <Skeleton
            height="24px"
            width="24px"
            borderRadius="8px"
            containerClassName="skeleton-container-span"
            className="skeleton-span"
          />
          <Skeleton
            borderRadius="100px"
            containerClassName="skeleton-container-span"
            className="skeleton-span"
          />
        </div>
        <Skeleton borderRadius="8px" className="skeleton-span" />
      </MapContainerLoading>
    );
  }

  return (
    <StyledMapContainer>
      <MapHeader>
        <TitleGraph>{t('mapa')}</TitleGraph>
        <InfoTooltip
          id="map"
          disabled={disabledTooltip}
        >
          <HistoryTooltip>
            <span>
              {t('numerosReferentesTotalEstado')}
            </span>
          </HistoryTooltip>
        </InfoTooltip>
        <span>
          {t('numerosReferentesTotalEstado')}
        </span>
      </MapHeader>
      {children}
    </StyledMapContainer>
  );
}
